import gql from "graphql-tag";
export default gql`
  mutation($order_id: String!, $variants_map: [VariantMap!]!, $is_personalized: Boolean) {
    mapOrder(order_id: $order_id, variants_map: $variants_map, is_personalized:$is_personalized)
  }
`;
